import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';

export const cancerscreenSampleValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        sampleType: {
          validators: [Validators.required],
        },
      },
    },
  },
};
